/************
 * Service Class
 * File Name ...: general.service.ts
 * Generated By : ianday on 5/2/24
 * Date ........: 5/2/24
 /************/
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';
import {Settings} from './settings';
import { CustomAction} from '../models/custom-action';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    public URLPath: string = Settings.getInstance().BASE_URL + 'general/matchlog/';

    constructor(private http: HttpClient) {
    }

    getMatchLogRecords(): Observable<any> {
        return this.http.get<any>(this.URLPath)
            .pipe(
                retry(1)
            );
    }
    getCustomActions(): Observable<CustomAction[]> {
    return this.http.get<[]>(Settings.getInstance().BASE_URL + 'general/settings/customactions/')
        .pipe(
            retry(1)
        );
}

}
